import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize',
})
export class FileSizePipe implements PipeTransform {
  transform(sizeString?: string): string {
    if (!sizeString) {
      return '';
    }
    // Extract numeric part and unit from the input string
    const sizeParts = sizeString.match(/^(\d+(\.\d+)?)(\s*)(KB|MB|GB|TB)$/i);
    if (!sizeParts) return 'Invalid size';

    let size = parseFloat(sizeParts[1]); // Numeric part
    let unit = sizeParts[4].toUpperCase(); // Unit part

    const units = ['KB', 'MB', 'GB', 'TB'];
    let index = units.indexOf(unit);

    // Convert size to the next unit if appropriate
    while (size >= 1024 && index < units.length - 1) {
      size /= 1024;
      index++;
    }

    // Return the rounded integer size with the appropriate unit
    return `${Math.floor(size)} ${units[index]}`;
  }
}
